import { Injectable } from "@angular/core";
import { SessionStorageService } from "ngx-webstorage";

@Injectable()
export class AppConfig{

    constructor(private sessionStorageService: SessionStorageService){


    }
    public load(){

       let cliente=this.getParameterByName("cliente");
       if(cliente!=null){
        this.sessionStorageService.store("clienteMaestra",cliente);

       }
       console.log(this.sessionStorageService.retrieve("clienteMaestra"));

    }

    private getParameterByName(name) {
        const url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
      }
    
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/app.config.ts